import { Observable } from "rxjs";
import { IFirebaseService } from "./firebase.service.interface";
import { Injectable } from "@angular/core";

@Injectable()
export class FirebaseMockService implements IFirebaseService {
  async getToken(): Promise<string> {
    console.info('Mock Firebase: returning fake token');
    // return 'mock-firebase-token-12345';
    return null;
  }

  onMessageReceived(): Observable<any> {
    return new Observable(observer => {
      console.info('Mock Firebase: no messages in browser');
    });
  }

  onTokenRefresh(): Observable<string> {
    return new Observable(observer => {
      console.info('Mock Firebase: no token refresh in browser');
    });
  }

  async grantPermission(): Promise<boolean> {
    console.info('Mock Firebase: returning no grant');
    return false;
  }

  async hasPermission(): Promise<boolean> {
    console.info('Mock Firebase: returning no permission');
    return false;
  }
}